import { Form } from "antd"
import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseModal from "../../../../components/layout/BaseModal"
import { returnAddressString } from "../../../../services/functions"
import { ReactComponent as MINUS } from "../../../../assets/MinusCircle.svg"
import { ObjectOnlyAddressType, ObjectType } from "../../../Objekte/types/types"
import BaseSelection from "../../../../components/elements/BaseSelection"
import { BillPost, PositionData } from "../../../../data/Types"
import { useContext, useEffect, useState } from "react"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseCheckbox from "../../../../components/elements/BaseCheckbox"

import Dropzone from "react-dropzone"
import { useAddBillMutation } from "../../api/services"
import { useQueryClient } from "@tanstack/react-query"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseSectionHeadline from "../../../../components/elements/BaseSectionHeadline"
import { PlusCircle } from "lucide-react"
import BaseDocElement from "../../../../components/elements/BaseDocElement"

type TBillFromElementModal = {
    id: string
    queryKey: string
    type: "task" | "orderrequest" | "report"
    modalId: number
    billData: {
        customer_id: string
        customer_name: string
        object_id: ObjectOnlyAddressType
        positions: PositionData[]
    }
    documents?: any[]
}

export default function BillFromElementModal(props: TBillFromElementModal) {
    // FE LOGIC
    const modalCon = useContext(ModalContext)
    const [newBill, setnewBill] = useState<BillPost | undefined>()
    const [documents, setdocuments] = useState<any[]>()
    const [form] = Form.useForm()
    // SETUP INITIAL VALUES
    useEffect(() => {
        if (props.billData) {
            form.setFieldsValue({
                customer_id: props.billData.customer_id,
                object_id: props.billData.object_id?._id,
                billType: "Rechnung",
                billCategorie: "Hausmeister",
                billDue: 14,
                manualReminderEnabled: false,
                positions: props.billData.positions,
            })
            setnewBill({
                date: new Date(),
                customer_id: props.billData.customer_id,
                object_id: props.billData.object_id?._id,
                billType: "Rechnung",
                billCategorie: "Hausmeister",
                billDue: 14,
                manualReminderEnabled: false,
                positions: props.billData.positions,
            } as unknown as BillPost)
        }
    }, [props.billData])

    // SEND BILL
    const queryClient = useQueryClient()
    const { mutate: addBill } = useAddBillMutation(queryClient, props.queryKey)
    const handleNewBill = () => {
        const formData = new FormData()
        const formValues = form.getFieldsValue()

        // CREATE BILL OBJECT WITH FORM VALUES
        const billData = {
            ...newBill,
            ...formValues,
            positions: formValues.positions || [],
        }

        formData.append("bill", JSON.stringify(billData))
        formData.append(props.type, JSON.stringify({ id: props.id }))
        documents?.forEach((doc: any) => {
            if (doc) {
                formData.append("additionalDocuments", doc)
            }
        })
        addBill(formData)
        form.resetFields()
        modalCon?.trigger(1)
    }

    console.log(documents)
    console.log(props.documents)
    return (
        <Form form={form} onFinish={handleNewBill}>
            <BaseModal
                title={`Rechnung aus ${props.type === "orderrequest" ? "Auftrag" : props.type === "task" ? "Aufgabe" : "Bericht"} erstellen`}
                modalId={props.modalId}
                bottomRow={
                    <div className="flex w-full justify-end">
                        <Form.Item>
                            <button type="submit" className="btn btn-primary btn-outline">
                                Absenden
                            </button>
                        </Form.Item>
                    </div>
                }>
                <div className="flex gap-4 w-full">
                    <BaseInputField classProps="mt-4 mb-2" disabled value={"Rechnung"} label={"Rechnungstyp"} type={"text"} onChange={() => {}} />
                    <Form.Item className="mt-4 mb-2 w-64" name={"billCategorie"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                        <BaseSelection
                            label={"Kategorie"}
                            placeholder={""}
                            data={["Hausmeister", "Schlüsseldienst", "Bau", "Vermietung"]}
                            setId={(e: string) => {
                                form.setFieldsValue({
                                    billCategorie: e,
                                })
                                setnewBill((prev) => ({
                                    ...(prev as BillPost),
                                    billCategorie: e,
                                }))
                            }}
                            defaultValue="Hausmeister"
                        />
                    </Form.Item>
                </div>
                <BaseInputField disabled value={props.billData.customer_name} label={"Kunde"} type={"text"} onChange={() => {}} />
                <BaseInputField disabled value={returnAddressString(props.billData.object_id as ObjectType)} label={"Objekt"} type={"text"} onChange={() => {}} classProps="my-2" />
                <Form.Item className="mb-2" name={"billDue"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                    <BaseSelection
                        label={"Rechnungsfrist in Tagen"}
                        placeholder={""}
                        data={["7", "14", "28"]}
                        setId={(e: string) => {
                            form.setFieldsValue({ billDue: Number(e) })
                            setnewBill((prev) => ({
                                ...(prev as BillPost),
                                billDue: Number(e),
                            }))
                        }}
                        defaultValue="14"
                    />
                </Form.Item>
                <Form.Item className="mb-2" name={"serviceDate"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                    <BaseInputField
                        label={"Leistungsdatum"}
                        type={"date"}
                        onChange={(e) =>
                            setnewBill((prev) => ({
                                ...(prev as BillPost),
                                serviceDate: e,
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item className="mb-2" name={"additionalText"} rules={[{ required: false, message: "Muss einen Wert enthalten" }]}>
                    <BaseInputArea
                        label={"Zusätzlicher Text auf der Rechnung (optional)"}
                        onChange={(e) =>
                            setnewBill((prev) => ({
                                ...(prev as BillPost),
                                additionalText: e,
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item className="mb-2 mt-2" name="manualReminderEnabled" rules={[{ required: false, message: "Muss einen Wert enthalten!" }]}>
                    <BaseCheckbox
                        prevent={!newBill?.manualReminderEnabled}
                        setcheck={(e) =>
                            setnewBill((prev) => ({
                                ...(prev as BillPost),
                                manualReminderEnabled: !newBill?.manualReminderEnabled,
                            }))
                        }
                        classProps="justify-start"
                        label={"Mahnungsfristen manuell setzen"}
                    />
                </Form.Item>
                {newBill?.manualReminderEnabled && (
                    <div className="flex w-full gap-4">
                        <Form.Item className="mt-4 mb-2 w-full" name={"reminderStartOffsetInDays"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputField
                                label={"Nach wieviel Tagen wird gemahnt?"}
                                type={"number"}
                                onChange={(e) =>
                                    setnewBill((prev) => ({
                                        ...(prev as BillPost),
                                        reminderStartOffsetInDays: Number(e),
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item className="mt-4 mb-2 w-full" name={"reminderIntervalInDays"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputField
                                label={"In welchem Abstand wird gemahnt? (in Tagen)"}
                                type={"number"}
                                onChange={(e) =>
                                    setnewBill((prev) => ({
                                        ...(prev as BillPost),
                                        reminderIntervalInDays: Number(e),
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item className="mt-4 mb-2 w-full" name={"maxReminders"} rules={[{ required: true, message: "Muss einen Wert enthalten" }]}>
                            <BaseInputField
                                label={"Wieviele Mahnungen werden verschickt?"}
                                type={"number"}
                                onChange={(e) =>
                                    setnewBill((prev) => ({
                                        ...(prev as BillPost),
                                        maxReminders: Number(e),
                                    }))
                                }
                                prevent
                            />
                        </Form.Item>
                    </div>
                )}
                <div className="w-full border-black pt-2 mb-3 border-b-2" />
                <BaseSectionHeadline
                    label="Positionen"
                    classProps="mt-4 !mb-1"
                    icon={
                        <PlusCircle
                            className="w-6 h-6 cursor-pointer"
                            onClick={() => {
                                const currentPositions = form.getFieldValue("positions") || []
                                form.setFieldValue("positions", [
                                    ...currentPositions,
                                    {
                                        position_id: "",
                                        description: "",
                                        tax: 19,
                                        unit: "",
                                        amount: 1,
                                        singlePrice: 0,
                                    },
                                ])
                            }}
                        />
                    }
                />
                <Form.List name="positions">
                    {(fields) => (
                        <>
                            {fields.map((field, index) => (
                                <div key={`position-${field.key}-${index}`} className="flex flex-col pb-2 justify-end w-full">
                                    <div className="flex w-full gap-2">
                                        <BaseInputField label={"Nr."} type={""} onChange={() => {}} width="w-16" disabled value={index + 1} />
                                        <Form.Item name={[field.name, "description"]} className="m-0 grow" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                            <BaseInputField label={"Beschreibung"} type={""} onChange={() => {}} width="grow" disabled={index === 0} />
                                        </Form.Item>
                                        <Form.Item name={[field.name, "unit"]} className="m-0" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                            <BaseInputField label={"Einheit"} type={"text"} onChange={() => {}} width="w-40" />
                                        </Form.Item>
                                        <Form.Item name={[field.name, "tax"]} className="m-0 w-20" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                            <BaseSelection
                                                label={"Steuer"}
                                                setId={(e) => {
                                                    const value = e === "19%" ? 19 : 7
                                                    form.setFieldValue(["positions", field.name, "tax"], value)
                                                }}
                                                classProps="!w-20"
                                                placeholder={""}
                                                data={["19 %", "7 %"]}
                                            />
                                        </Form.Item>
                                        <Form.Item name={[field.name, "amount"]} className="m-0 w-20" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                            <BaseInputField label={"Menge"} type={"number"} onChange={() => {}} width="w-20" disabled={index === 0} />
                                        </Form.Item>
                                        <Form.Item name={[field.name, "singlePrice"]} className="m-0" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                                            <BaseInputField label={"Einzelpreis"} type={"number"} onChange={() => {}} width="w-40" disabled={props.type === "orderrequest"} />
                                        </Form.Item>
                                        {fields.length > 1 && (
                                            <button
                                                type="button"
                                                className="w-6 h-6 my-auto -ml-1 cursor-pointer"
                                                onClick={() => {
                                                    const currentPositions = form.getFieldValue("positions") || []
                                                    const updatedPositions = currentPositions.filter((_: any, idx: number) => idx !== field.name)
                                                    form.setFieldValue("positions", updatedPositions)
                                                }}>
                                                <MINUS className="w-6 h-6" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </Form.List>

                <div className="w-full border-black pt-4 mb-3 border-b-2" />
                <BaseSectionHeadline label="Dokumente" classProps="mt-4 !mb-1" />
                {props.documents && props.documents.map((document) => <BaseDocElement label={document.title} />)}
                <Dropzone onDrop={(acceptedFiles) => setdocuments(acceptedFiles)}>
                    {({ getRootProps, getInputProps }) => (
                        <div className={`w-full h-40 cursor-pointer flex border rounded-default my-4 ${!documents ? "items-center justify-center" : "flex-wrap p-4 gap-4"}`} {...getRootProps()}>
                            <input {...getInputProps()} />
                            {!documents && <p className="uppercase font-semibold text-gray-400">Dokumente hier ablegen oder Klicken und auswählen</p>}
                            {documents &&
                                documents?.map((item: any, index: number) => (
                                    <div className="h-32 w-32 border rounded-default flex items-center justify-center">
                                        <p className="truncate">{item.name}</p>
                                    </div>
                                ))}
                        </div>
                    )}
                </Dropzone>
            </BaseModal>
        </Form>
    )
}
